import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {Observable} from 'rxjs';
import {QrCodeInterface} from '../models/qr-code.interface';
import {ExtranetService} from './extranet.service';

@Injectable()
export class EsimService {

  constructor(private apiService: ApiService, private extranetService: ExtranetService) {}

  /**
   * Get eSim phones
   */
  getESimPhones() {
    return this.apiService.get<Array<string>>('vitrine/esim/compatible/phones');
  }

  getQrCode(phoneNumber: string, password): Observable<QrCodeInterface> {
    let extranetToken = null;
    if (this.extranetService.getSupportUser()) {
      extranetToken = this.extranetService.getSupportUser().token;
    }
    return this.apiService.post<QrCodeInterface>('qr-code', {phoneNumber, password, extranetToken});
  }
}
